/**
 * スタンプの押印面
 *
 * ルートのタイムラインと地図のポップアップで同じ見た目を使う。押せるかどうかは呼び出し側の責務。
 */

import { Check, Stamp } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = {
  stamped: boolean
  /** 右上に出す「2/3」のような獲得数 */
  badge?: string
  size?: 'sm' | 'md'
}

export const StampFace = ({ stamped, badge, size = 'md' }: Props) => (
  <span
    className={cn(
      'relative flex shrink-0 items-center justify-center rounded-full border-2 border-dashed transition-colors',
      size === 'md' ? 'size-8' : 'size-7',
      stamped
        ? 'border-solid border-emerald-500 bg-emerald-500 text-white'
        : 'border-muted-foreground/40 text-muted-foreground/70 active:bg-accent',
    )}
  >
    {stamped ? <Check size={size === 'md' ? 16 : 14} /> : <Stamp size={size === 'md' ? 14 : 12} />}
    {badge && (
      <span className="absolute -top-1 -right-1 rounded-full bg-background px-1 text-[9px] font-bold tabular-nums text-muted-foreground ring-1 ring-border">
        {badge}
      </span>
    )}
  </span>
)
